import { useEffect, useState } from 'react';
import type { MoveAttachmentsJob } from '@atlas/shared';
import { MoveAttachmentsLog } from '../components/MoveAttachmentsLog.js';
import { NewMoveAttachmentsForm } from '../components/NewMoveAttachmentsForm.js';
import { MoveAttachmentsTable } from '../components/MoveAttachmentsTable.js';
import { subscribeToMoveAttachments } from '../lib/moveAttachments.js';

export function MoveAttachmentsPage() {
  const [jobs, setJobs] = useState<Array<MoveAttachmentsJob & { id: string }>>([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    return subscribeToMoveAttachments(
      (list) => {
        setJobs(list);
        setLoading(false);
        setLoadError(null);
      },
      (err) => {
        setLoadError(err.message);
        setLoading(false);
      },
    );
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-8 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-[#37352f] tracking-tight">
          Move attachments
        </h1>
        <p className="text-sm text-[#73726e] mt-1">
          Copy an agency's attachments from a source export into the import area.
          Each source arrives in a different layout, so you pick the source first.
        </p>
      </div>

      <div className="max-w-xl mb-10">
        <NewMoveAttachmentsForm existingJobs={jobs} />
      </div>

      {loadError && (
        <p className="text-sm text-[#e03e3e] bg-[#fbe8e8] border border-[#f5c6c6] rounded px-3 py-2 mb-4">
          Could not load runs: {loadError}
        </p>
      )}

      {(loading || jobs.length > 0) && (
        <MoveAttachmentsTable jobs={jobs} loading={loading} />
      )}

      <MoveAttachmentsLog />
    </div>
  );
}
